<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea updateLog">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <el-table :data="logData" style="width: 100%" v-loading="tableloading">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="update_type_name" label="更新类型"></el-table-column>
        <el-table-column prop="device_name" label="适用产品"></el-table-column>
        <el-table-column prop="apply_versions" label="适用固件版本"></el-table-column>
        <el-table-column prop="current_versions" label="更新版本号"></el-table-column>
        <el-table-column label="更新设备">
          <template slot-scope="scope">
            <el-button type="text" @click="lookDevice(scope.row.queue_id)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间"></el-table-column>
        <el-table-column label="是否更新">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="col909">未更新</span>
            <span v-else-if="scope.row.status == 1" class="col67C">已更新</span>
            <span v-else class="colE6A">更新中</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging" v-if="total>limits">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="limits"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="查看更新设备" :visible.sync="deviceDio" width="800px">
      <div class="contDio">
        <el-table :data="deviceData" style="width:100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="device_no_id" label="设备ID"></el-table-column>
          <el-table-column prop="device_name" label="设备名称"></el-table-column>
          <el-table-column prop="batch" label="批次"></el-table-column>
          <el-table-column prop="company_name" label="所属公司"></el-table-column>
          <el-table-column label="更新状态">
            <template slot-scope="scope">
              <span class="col909" v-if="scope.row.status == '0'">未更新</span>
              <span class="col67C" v-else-if="scope.row.status == '1'">已更新</span>
              <span class="colE6A" v-else-if="scope.row.status == '2'">正在更新</span>
              <span class="colF56" v-else>更新失败</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { systemApi } from "../../../../../static/js/api.js"
  import { showToast, deepCopy } from '../../../../../static/js/utility/utility';
  export default {
    name: 'updateLog',
    data(){
      return {
        tableloading:false,
        logData:[],//记录列表
        curr:1,
        limits:10,
        total:0,

        deviceDio:false,
        deviceData:[],
      }
    },
    components: {
      BreadCrumb
    },
    async created(){
      this.updateLogList()
    },
    methods:{
      //查看所属设备列表
      async lookDevice(queue_id){
        let that = this
        const dataObj = {
          'queue_id': queue_id,
        }
        const res = await systemApi.updateDeviceOnline(dataObj)
        if(res.meta.code == 200){
          that.deviceData = res.data
          that.deviceDio = true;
        }else{
          showToast(res.meta.message)
        }
      },
      //获取记录列表列表
      async updateLogList(curr,limits){
        let that = this;
        const dataObj = {
          'page': curr ? curr : that.curr,
          'perPage': limits ? limits : that.limits,
        }
        this.tableloading = true;
        const res = await systemApi.updateLogList(dataObj)
        if(res.meta.code == 200) {
          that.logData = res.data.list
          that.total = parseInt(res.data.count)
          that.tableloading = false;
        }else{
          this.tableloading = false;
          showToast(res.meta.message)
        }
      },
      //点击当前页调用接口
      CurrentChange(val){
        this.curr = val
        this.updateLogList(val)
      },
    }
  }
</script>
<style lang="scss">
.updateLog{
  .mainBodyContent{
    min-height: calc(100vh - 194px);
  }
  .col909{
    color: #909399;
  }
  .col67C{
    color: #67C23A;
  }
  .colE6A{
    color: #E6A23C;
  }
  .colF56{
    color: #F56C6C;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Page/System/OnlineUpdate/updateLog.vue